import type { ILocalizedMetadata, IRelationships, LocaleEnum } from '@/services';
import { ALMResourceContentTypes } from '@/entities';

export const resourceType = 'livestream';
export interface IResourceResponse {
  id: string;
  type: typeof resourceType;
  relationships?: IRelationships;
  attributes: {
    localizedMetadata: ILocalizedMetadata[];
    imageUrl: boolean;
    authorDesiredDuration?: number;
    contentType: ALMResourceContentTypes;
    contentZipSize: number;
    contentZipUrl: string;
    dateCreated: string;
    desiredDuration: number;
    hasQuiz: boolean;
    hasToc: boolean;
    isDefault: boolean;
    locale: LocaleEnum;
    location?: string;
    name: string;
    onlyQuiz: boolean;
    reportingInfo: string;
    reportingType: string;
    seatLimit?: number;
    instructorNames?: [string];
    dateStart?: string;
    completionDeadline?: string;
  };
}
